import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllProfessionsUseCaseInterface } from 'domain/usecases';

import { HttpStatusCode } from '../../protocols/http';

export class RemoteGetAllProfessions
  implements GetAllProfessionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params?: GetAllProfessionsUseCaseInterface.Params,
  ): Promise<GetAllProfessionsUseCaseInterface.Result> {
    let requestUrl = this.url;

    if (params && params.query) {
      requestUrl = generateUrl(this.url, params);
    }
    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
